import { Component, inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ServiceListItem } from '../../../../services/service.common.model';
import { selectServiceByUrl } from '../../../../store/selectors/app.selectors';
import {
  ProvidingInformationAboutTravelConditionsForm
} from './forms/providing-information-about-travel-conditions.form';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { BreadcrumbsComponent } from '../../../../common/breadcrumbs/breadcrumbs.component';
import { ContentComponent } from '../../../../components/content/content.component';
import {
  ExposedMapControlComponent
} from '../../../../common/exposed-map/exposed-map-control/exposed-map-control.component';
import { ValidationErrorsComponent } from '../../../../common/validation-errors/validation-errors.component';
import { selectLoading, selectPending } from '../../../../store/selectors/app.selectors';
import { SpinnerComponent } from '../../../../common/spinner/spinner.component';
import { SmartgemRoadConditionReportRequestService } from '../../../../openapi';
import { SmartGemCommonService } from '../../../../services/smart-gem.common.service';

@Component({
  selector: 'app-providing-information-about-travel-conditions',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    BreadcrumbsComponent,
    ContentComponent,
    RouterLink,
    ExposedMapControlComponent,
    ValidationErrorsComponent,
    SpinnerComponent
  ],
  providers: [
    ProvidingInformationAboutTravelConditionsForm
  ],
  templateUrl: './providing-information-about-travel-conditions.component.html'
})
export class ProvidingInformationAboutTravelConditionsComponent {

  private store$: Store = inject(Store);

  private route: ActivatedRoute = inject(ActivatedRoute);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public serviceType: Signal<ServiceListItem | null> = this.store$.selectSignal(selectServiceByUrl('udostepnienie-informacji-o-warunkach-przejazdu'));

  public form: ProvidingInformationAboutTravelConditionsForm = inject(ProvidingInformationAboutTravelConditionsForm);

  private smartGemService: SmartGemCommonService = inject(SmartGemCommonService);

  public onSubmit(): void {
    if (this.form.valid) {
      this.smartGemService.downloadRoadConditionReportPdf(this.form.toWriteModel())
        .subscribe();
    } else {
      this.form.markAllAsTouched();
    }
  }
}
